var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid2';
import MapCard from '../cards/MapCard';
import { DEFAULT_MAP_CENTER, RADIUS_SELECT_OPTIONS } from '../../../constants';
import SelectedPlaceChip from '../buttons/SelectedPlaceChip';
import { AppConfig } from '../../../app.config';
import MapUserChip from '../buttons/MapUserChip';
import { useAppContext } from '../../context/AppContext';
import theme from '../../Theming/DefaultTheme';
var placeSelectionsContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 60,
    padding: 0,
    margin: 0,
};
var placeSelectionsContainerInner = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    width: '100%',
    gap: 6,
    padding: 10,
    minHeight: 65,
    backgroundColor: theme.palette.secondary.light,
};
var userChipsContainer = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: 5,
    padding: 5,
};
var titleContainer = {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 0px 14px 14px',
    gap: 6,
    backgroundColor: theme.palette.primary.main,
};
var MapSection = function () {
    var _a, _b, _c, _d;
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var _e = useAppContext(), user = _e.user, mapSession = _e.mapSession, updateSession = _e.updateSession;
    var _f = useState({
        userLocation: DEFAULT_MAP_CENTER,
        searchInputDisabled: AppConfig.environment == 'development',
        mobileSearchPanelOpen: false,
        placeSearchFilters: {
            radius: RADIUS_SELECT_OPTIONS[2], // Default to 10 mile radius
        },
    }), componentState = _f[0], setComponentState = _f[1];
    var updateComponentState = function (newComponentState) {
        setComponentState(function (componentState) {
            return __assign(__assign({}, componentState), newComponentState);
        });
    };
    useEffect(function () {
        // Get the user's current position
        console.log('Getting user location');
        navigator.geolocation.getCurrentPosition(function (position) {
            var _a = position.coords, latitude = _a.latitude, longitude = _a.longitude;
            updateComponentState(__assign(__assign({}, componentState), { userLocation: {
                    lat: latitude,
                    lng: longitude,
                } }));
        });
    }, []);
    // useMemo(() => {
    //   const selectedPlacesCopy = [...componentState.selectedPlaces];
    //   // Consolidate votes by placeId (itemId)
    //   const placeVotesByPlaceId = componentState.placeVotes.reduce(
    //     (acc, vote) => {
    //       if (!acc[vote.itemId]) {
    //         acc[vote.itemId] = 0;
    //       }
    //       acc[vote.itemId]++;
    //       return acc;
    //     },
    //     {} as { [key: string]: number }
    //   );
    //   //Update the selected place votes based on consolidated votes
    //   selectedPlacesCopy.forEach((selectedPlace) => {
    //     // Get the place vote count from the consolidated votes
    //     if (selectedPlace?.placeId)
    //       selectedPlace.voteCount =
    //         placeVotesByPlaceId[selectedPlace.placeId] || 0;
    //   });
    //   updateComponentState({
    //     ...componentState,
    //     selectedPlaces: selectedPlacesCopy,
    //   });
    // }, [componentState.placeVotes]);
    var onClearSelectedPlace = function () {
        updateComponentState(__assign(__assign({}, componentState), { selectedPlace: undefined }));
    };
    var onRadiusChange = function (radius) {
        console.log('Radius changed:', radius);
        updateComponentState(__assign(__assign({}, componentState), { placeSearchFilters: __assign(__assign({}, componentState.placeSearchFilters), { radius: radius }) }));
    };
    var castVote = function (voterId, itemId) {
        if (!mapSession)
            return;
        var votesCopy = __spreadArray([], mapSession.votes, true);
        var selectedPlacesCopy = __spreadArray([], mapSession.mapData.pins, true);
        // If the voter has already voted then remove the vote
        // If the voter has not voted then add the vote
        var existingVote = votesCopy.find(function (vote) { return vote.voterId === voterId && vote.itemId === itemId; });
        if (existingVote) {
            votesCopy = votesCopy.filter(function (vote) { return !(vote.voterId === voterId && vote.itemId === itemId); });
        }
        else {
            votesCopy.push({ voterId: voterId, itemId: itemId });
        }
        // Consolidate the votes by placeId (itemId)
        var placeVotesByPlaceId = votesCopy.reduce(function (acc, vote) {
            if (!acc[vote.itemId]) {
                acc[vote.itemId] = 0;
            }
            acc[vote.itemId]++;
            return acc;
        }, {});
        // Update the voteCount value on the selected places based on the consolidated votes
        selectedPlacesCopy.forEach(function (selectedPlace) {
            if (selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.placeId)
                selectedPlace.voteCount =
                    placeVotesByPlaceId[selectedPlace.placeId] || 0;
        });
        // Update the map session with the new votes and selected places
        var mapSessionCopy = __assign({}, mapSession);
        var newMapSession = __assign(__assign({}, mapSessionCopy), { votes: votesCopy, mapData: {
                pins: selectedPlacesCopy,
            } });
        updateSession(newMapSession);
    };
    var userVoted = function (selectedPlace) {
        // Look through the votes casted and see if the
        // user has already voted for the selected place
        if (mapSession === null || mapSession === void 0 ? void 0 : mapSession.votes) {
            return mapSession === null || mapSession === void 0 ? void 0 : mapSession.votes.some(function (vote) {
                return vote.voterId === (user === null || user === void 0 ? void 0 : user.userId) && vote.itemId === selectedPlace.placeId;
            });
        }
        else
            return false;
    };
    var handlePlaceSelected = function (selectedPlace) {
        updateComponentState(__assign(__assign({}, componentState), { selectedPlace: selectedPlace }));
    };
    var handlePlaceAdded = function (addedPlace) {
        if (!mapSession)
            return;
        var newSelectedPlaces = __spreadArray([], mapSession.mapData.pins, true);
        // Dont add the place if it's already in the list or
        // if there are already 6 places selected
        var placeAlreadyAdded = newSelectedPlaces.some(function (selectedPlace) { return selectedPlace.placeId === addedPlace.placeId; });
        if (placeAlreadyAdded)
            return;
        if ((newSelectedPlaces === null || newSelectedPlaces === void 0 ? void 0 : newSelectedPlaces.length) >= 6)
            return;
        // Create a new ISelectedPlace and add it to the list
        // selected places
        var newSelectedPlace = __assign(__assign({}, addedPlace), { voteCount: 0 });
        newSelectedPlaces.push(newSelectedPlace);
        // Update the map session with the new selected places
        var mapSessionCopy = __assign({}, mapSession);
        var newMapSession = __assign(__assign({}, mapSessionCopy), { mapData: {
                pins: newSelectedPlaces,
            } });
        updateSession(newMapSession);
    };
    var handlePlaceRemoved = function (removedPlace) {
        var _a, _b;
        if (!mapSession || ((_b = (_a = mapSession === null || mapSession === void 0 ? void 0 : mapSession.mapData) === null || _a === void 0 ? void 0 : _a.pins) === null || _b === void 0 ? void 0 : _b.length) === 0)
            return;
        // Remove the place from the selected places list
        var newSelectedPlaces = mapSession.mapData.pins.filter(function (place) { return place.placeId !== removedPlace.placeId; });
        // Update the map session with the new selected places
        var mapSessionCopy = __assign({}, mapSession);
        var newMapSession = __assign(__assign({}, mapSessionCopy), { mapData: {
                pins: newSelectedPlaces,
            } });
        updateSession(newMapSession);
    };
    var handlePlaceVoteClicked = function (selectedPlace) {
        if ((user === null || user === void 0 ? void 0 : user.userId) && selectedPlace.placeId) {
            castVote(user.userId, selectedPlace.placeId);
        }
    };
    return (_jsx(Box, { style: { width: '100%' }, children: _jsxs(Grid, { container: true, spacing: 0, children: [_jsx(Grid, { size: { lg: 12, xs: 12 }, children: _jsxs(Box, { style: titleContainer, children: [_jsx(Typography, { variant: 'h4', color: 'white', children: mapSession === null || mapSession === void 0 ? void 0 : mapSession.sessionId }), _jsx(Box, { style: userChipsContainer, sx: __assign({}, (isMobile && {
                                    flexDirection: 'row',
                                    overflowX: 'auto',
                                    padding: 5,
                                    gap: 5,
                                    WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
                                    '&::-webkit-scrollbar': {
                                        display: 'none', // Hide scrollbar for WebKit browsers
                                    },
                                    '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
                                    'scrollbar-width': 'none', // Hide scrollbar for Firefox
                                })), children: (_a = mapSession === null || mapSession === void 0 ? void 0 : mapSession.users) === null || _a === void 0 ? void 0 : _a.map(function (user, index) {
                                    return _jsx(MapUserChip, { user: user }, index);
                                }) })] }) }), _jsx(Grid, { size: { lg: 12, xs: 12 }, children: _jsx(Box, { style: placeSelectionsContainer, children: mapSession && ((_b = mapSession === null || mapSession === void 0 ? void 0 : mapSession.mapData.pins) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (_jsxs(Box, { style: placeSelectionsContainerInner, sx: __assign({}, (isMobile && {
                                flexDirection: 'row',
                                overflowX: 'auto',
                                padding: 5,
                                gap: 5,
                                WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
                                '&::-webkit-scrollbar': {
                                    display: 'none', // Hide scrollbar for WebKit browsers
                                },
                                '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
                                'scrollbar-width': 'none', // Hide scrollbar for Firefox
                            })), children: [_jsx(Typography, { variant: 'body1', color: 'white', children: "".concat((_c = mapSession === null || mapSession === void 0 ? void 0 : mapSession.mapData.pins) === null || _c === void 0 ? void 0 : _c.length, "/6") }), (_d = mapSession === null || mapSession === void 0 ? void 0 : mapSession.mapData) === null || _d === void 0 ? void 0 : _d.pins.map(function (selectedPlace, index) {
                                    return (_jsx(SelectedPlaceChip, { selectedPlace: selectedPlace, userVoted: userVoted(selectedPlace), onClick: handlePlaceSelected, onRemove: handlePlaceRemoved, onVoteClick: handlePlaceVoteClicked }, index));
                                })] })) : (_jsx(Box, { style: placeSelectionsContainerInner, children: _jsx(Typography, { variant: 'body1', color: 'white', children: "No places selected yet" }) })) }) }), _jsx(Grid, { size: { lg: 12, xs: 12 }, children: _jsx(MapCard, { userLocation: componentState.userLocation, selectedPlace: componentState === null || componentState === void 0 ? void 0 : componentState.selectedPlace, selectedPlaces: mapSession ? mapSession === null || mapSession === void 0 ? void 0 : mapSession.mapData.pins : [], searchRadius: componentState.placeSearchFilters.radius, searchInputDisabled: componentState.searchInputDisabled, onPlaceInfoWindowClose: onClearSelectedPlace, onPlaceSelected: handlePlaceSelected, onPlaceAdded: handlePlaceAdded, onClearSelectedPlace: onClearSelectedPlace, onRadiusChange: onRadiusChange }) })] }) }));
};
export default MapSection;
